module.exports = __webpack_public_path__ + "img/logo2.2b619b38.png";